"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuperScript = void 0;
var _stitches = require("../../../../stitches.config");
var SuperScript = (0, _stitches.styled)('sup', {
  fontWeight: 400,
  fontSize: 10,
  lineHeight: '12px'
});
exports.SuperScript = SuperScript;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');